module.exports = __webpack_public_path__ + "static/media/Pool4.5f0789ac.jpg";